





























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AuthorizedSignerTable from "@/employee/components/settings/profile/AuthorizedSignerTable.vue";
import { useAuthorizedSignerStore } from "@/employee/store/authorizedSigner";
import { useFamilyStore } from "@/employee/store/family";
import { AuthorizedSigner, AuthorizedSignerStatus, FamilyMember } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import AddAuthorizedSigner from "@/employee/components/settings/profile/AddAuthorizedSigner.vue";
import _ from "lodash";

@Component({
  components: {
    GenericLoadingSpinner,
    AuthorizedSignerTable,
    AddAuthorizedSigner
  }
})
export default class AuthorizedSigners extends Vue {
  authorizedSignerStore = useAuthorizedSignerStore();
  featureFlagStore = useFeatureFlagStore();
  familyStore = useFamilyStore();

  mounted (): void {
    this.authorizedSignerStore.loadAuthorizedSigners();
    this.authorizedSignerStore.loadDebitCardEligibility();
  }

  // sync authorized signers when authorized dependents (dependents who are linked as authorized signers) are updated
  @Watch("familyStore.familyMembers")
  dependentsUpdated (value: FamilyMember[], newValue: FamilyMember[]) {
    const changes = _.difference(value, newValue);
    const dependentExternalIds =  changes.map(f => f.externalId);

    if (_.isEmpty(dependentExternalIds)) {
        return;
    }

    const authorizedDependentIds = this.authorizedSigners.map(a => a.userFamilyMemberExternalId);
    if (_.isEmpty(authorizedDependentIds)) {
      return;
    }

    const authorizedDependentChanged = authorizedDependentIds.some(id => dependentExternalIds.includes(id));
    if (authorizedDependentChanged === false) {
      return;
    }

   this.authorizedSignerStore.loadAuthorizedSigners({ force: true });
  }

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }
  get isLoaded (): boolean {
    return this.authorizedSignerStore.isAuthoriziedSignersLoaded;
  }

  get authorizedSigners (): AuthorizedSigner[] {
    return Object.keys(this.authorizedSignerStore.authorizedSigners).map(key => this.authorizedSignerStore.authorizedSigners[key]) ;
  }

  get activeAuthorizedSigners (): AuthorizedSigner[] {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Active);
  }

  get hasActiveAuthorizedSigners (): boolean {
    return this.activeAuthorizedSigners && this.activeAuthorizedSigners.length > 0;
  }

  get inactiveAuthorizedSigners (): AuthorizedSigner[]  {
    return this.authorizedSigners.filter(x => x.status === AuthorizedSignerStatus.Inactive);
  }

  get hasInactiveAuthorizedSigners (): boolean {
    return this.inactiveAuthorizedSigners && this.inactiveAuthorizedSigners.length > 0;
  }
}
